module.exports = __webpack_public_path__ + "img/3f0ef3a07308be323a047f6d8676efd1.png";